module.exports = __webpack_public_path__ + "img/Mask@2x(1).cca4f83c.png";